module.exports = __webpack_public_path__ + "static/media/footer-bnr_1920x100.5d23b7c7.png";